
import TranResourcesApi from './src/Tranresources'
import RegionThresholdApi from './src/RegionThreshold'
import RegionList from './src/RegionList'


let apis = {
   TranResourcesApi,
   RegionThresholdApi,
   RegionList
};

export default apis;
